import {isNullOrUndef} from "chart.js/helpers";
// import I18n from 'i18n-js';
// I18n.locale = window.I18n.locale;

const select2Ids = ['battery_group_id','battery_brand_id','battery_bci_id','battery_condition_id','vehicle_vehicles_years_id','vehicle_vehicles_makes_id','vehicle_vehicles_models_id','vehicle_vehicles_engines_id']

/**
 * Unbinds the 'select2:select' event from one or more Select2 elements.
 *
 * @param {...string} select_ids - A comma-separated list of element IDs (without the #).
 */
function clearSelect2(...select_ids) {
    if (select_ids.length === 0) {
        return;
    }
    // Build a single jQuery selector for all IDs.
    const selector = select_ids.map(id => '#' + id).join(', ');
    // Use the combined selector to turn off the event for all matched elements.
    $(selector).off('select2:select');
}

function setupOutgoingsForm() {
    const form = document.getElementById("outgoings-form");
    if (form) {
        // console.log('Outgoings turbolinks loaded.')
        $('#add-outgoing-item').on('click', function(e) {
            e.preventDefault();

            var uniqueId = new Date().getTime();
            var templateHtml = $('#outgoing-item-template').html();
            var newRowHtml = templateHtml.replace(/NEW_RECORD/g, uniqueId);

            var $newRow = $(newRowHtml);

            $newRow.find('.select2-container').remove();
            $newRow.find('select')
                .removeClass('select2-hidden-accessible')
                .removeAttr('data-select2-id aria-hidden tabindex id');
            $newRow.find('option').removeAttr('data-select2-id');

            $('#outgoing-items-container').append($newRow);

            $newRow.find('select').select2({
                width: '100%',
                theme: 'classic' // Quítalo si notas que el estilo no cuadra con el original
            });
        });
        $(document).on('click', '.remove-quote-item', function(e) {
            e.preventDefault();
            var $row = $(this).closest('.quote-item-row');
            var $destroyField = $row.find('.destroy-flag');

            // Si el campo existe (es un registro guardado o el template lo incluyó)
            if ($destroyField.length > 0) {
                $destroyField.val('1'); // Marcamos para eliminar en Rails
                $row.hide();            // Lo ocultamos de la vista del usuario
            } else {
                // Si por alguna razón no hay campo _destroy (ej. registro nuevo no guardado)
                $row.remove();
            }
        });
    }
}

function destroyOutgoingsForm() {
    const form = document.getElementById("outgoings-form");
    if (form) {
        // console.log("Cleanup outgoings-form...")
        $('#add-outgoing-item').off('click');
        // clearSelect2(...select2Ids)
    }
}
document.addEventListener("turbolinks:load", setupOutgoingsForm);
// document.addEventListener('turbolinks:before-cache', destroyOutgoingsForm);
window.addEventListener('beforeunload', (event) => {
    destroyOutgoingsForm();
});


